import React from 'react'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'

import { useGetAttachedNegativeKeywordsLists } from '../../hooks'

import { dv360NegativeKeywordListsWasLoadedSelector } from '../../../../../../../../modules/selectors/dv360Constants'

import useDrawerFormStyles from '../../../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const NegativeKeywordsListSectionPreview = () => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormStyles()
  const classes = useStyles()

  const dv360NegativeKeywordListsWasLoaded = useSelector(dv360NegativeKeywordListsWasLoadedSelector)

  const attachedNegativeKeywordsLists = useGetAttachedNegativeKeywordsLists()

  if (!dv360NegativeKeywordListsWasLoaded) {
    return (
      <section className={classnames(drawerFormClasses.section, classes.negativeKeywordsListSection)}>
        <Skeleton count={4} />
      </section>
    )
  }

  return (
    <section className={classnames(drawerFormClasses.section, classes.negativeKeywordsListSection)}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Negative keywords lists')}</h3>
      {attachedNegativeKeywordsLists.map(negativeKeywordList => (
        <p>{negativeKeywordList.name}</p>
      ))}
    </section>
  )
}

export default NegativeKeywordsListSectionPreview
